import * as React from 'react';
import { BreakpointDesktop, BreakpointEqualsMobile, BreakpointMobile, BreakpointToMobile, } from '@wix/wix-ui-icons-common';
export var IndicationType;
(function (IndicationType) {
    // noinspection JSUnusedGlobalSymbols
    IndicationType["DesktopAndTabletOnly"] = "DesktopAndTabletOnly";
    IndicationType["CascadesToLower"] = "CascadesToLower";
    IndicationType["AppliesToAll"] = "AppliesToAll";
    IndicationType["MobileOnly"] = "MobileOnly";
})(IndicationType || (IndicationType = {}));
export var indicationIcons = {
    DesktopAndTabletOnly: function () { return React.createElement(BreakpointDesktop, null); },
    CascadesToLower: function () { return React.createElement(BreakpointToMobile, null); },
    AppliesToAll: function () { return React.createElement(BreakpointEqualsMobile, null); },
    MobileOnly: function () { return React.createElement(BreakpointMobile, null); },
};
export var breakpointIndicationsExperiment = 'specs.bookings.showPerBreakpointIndications';
//# sourceMappingURL=common.js.map